import { c as _c } from "react/compiler-runtime";
import { type MintCountdownState, useMintCountdownState } from "@/hooks/useMintCountdownState";
import NowMintingCountdownActive from "./NowMintingCountdownActive";
import NowMintingCountdownLoading from "./NowMintingCountdownLoading";
import NowMintingCountdownStatus from "./NowMintingCountdownStatus";
interface NowMintingCountdownProps {
  readonly nftId: number;
  readonly hideMintBtn?: boolean;
  readonly hideNextDrop?: boolean;
  readonly fullWidth?: boolean;
}
export default function NowMintingCountdown(t0) {
  const $ = _c(10);
  const {
    nftId,
    hideMintBtn,
    hideNextDrop,
    fullWidth
  } = t0;
  let t1;
  if ($[0] !== hideMintBtn) {
    t1 = hideMintBtn === undefined ? undefined : {
      hideMintBtn
    };
    $[0] = hideMintBtn;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const state = useMintCountdownState(nftId, t1);
  const t2 = `tw-group tw-relative tw-mt-auto ${fullWidth ? "tw-w-full" : ""}`;
  let t3;
  if ($[2] !== hideNextDrop) {
    t3 = hideNextDrop !== undefined && {
      hideNextDrop
    };
    $[2] = hideNextDrop;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== state || $[5] !== t3) {
    t4 = <NowMintingCountdownContent state={state} {...t3} />;
    $[4] = state;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function NowMintingCountdownContent(t0) {
  const $ = _c(8);
  const {
    state,
    hideNextDrop
  } = t0;
  switch (state.type) {
    case "loading":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <NowMintingCountdownLoading />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "error":
    case "sold_out":
    case "finalized":
      {
        let t1;
        if ($[1] !== hideNextDrop) {
          t1 = hideNextDrop !== undefined && {
            hideNextDrop
          };
          $[1] = hideNextDrop;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        let t2;
        if ($[3] !== state.type || $[4] !== t1) {
          t2 = <NowMintingCountdownStatus type={state.type} {...t1} />;
          $[3] = state.type;
          $[4] = t1;
          $[5] = t2;
        } else {
          t2 = $[5];
        }
        return t2;
      }
    case "countdown":
      {
        let t1;
        if ($[6] !== state.countdown) {
          t1 = <NowMintingCountdownActive countdown={state.countdown} />;
          $[6] = state.countdown;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
  }
}